import { render, staticRenderFns } from "./orderExpend.vue?vue&type=template&id=1026b0d1&scoped=true&"
import script from "./orderExpend.vue?vue&type=script&lang=js&"
export * from "./orderExpend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1026b0d1",
  null
  
)

export default component.exports